import {
  IPromoDetail,
  IPromoDetailRepository,
  IUpdatePromoProgramParams,
} from "@/core/repositories/promotion/IPromoDetail.repository";

export class UpdatePromoProgramUseCase {
  constructor(private readonly repo: IPromoDetailRepository) {}

  async execute(params: IUpdatePromoProgramParams): Promise<IPromoDetail> {
    return this.repo.updatePromoProgram(params);
  }
}
